import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ContentImage } from '@frontend/vanilla/core';

@Component({
    selector: 'criteria-steps',
    templateUrl: './criteria-steps.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgStyle],
})
export class CriteriaStepsComponent {
    @Input() stepDescription: string;
    @Input() stepImage: ContentImage;
    @Input() stepPercentage: string;
}
